import {flatMap, uniq} from 'lodash';

// @ts-expect-error config needs to be rewritten as ts
import {baseCdnUrl} from '~/shared/config';
import {EnumOfficeSupplyOptions} from '~/shared/services/analytics/analyticsModels';

import {ITenbisForBusinessCategory} from './interface';

export const categories: ITenbisForBusinessCategory[] = [
  {
    label: {
      he: 'מצרכים למטבחי חברה',
      en: 'Corporate Kitchen',
    },
    id: EnumOfficeSupplyOptions.KITCHEN_SUPPLIES,
    iconUrl: `${baseCdnUrl}/restaurant-cuisine-type-icon-image/groceriesCategory.svg`,
    cuisineIdsToFilterBy: ['supermarket', 'wholesale'],
  },
  {
    label: {
      he: 'ציוד ושירותים לחברות',
      en: 'Supplies & Services',
    },
    id: EnumOfficeSupplyOptions.EQUIPMENT_SERVICES,
    iconUrl: `${baseCdnUrl}/restaurant-cuisine-type-icon-image/officeSuppliesCategory.svg`,
    cuisineIdsToFilterBy: [
      'officeSupplies',
      'disposableDishes',
      'coffeeSolutions',
      'flowers',
      'deliveryServices',
      'giftCards',
      'officeFurniture',
      'ITSolutions',
      'others',
    ],
  },
  {
    label: {
      he: 'אירועים וכיבודים לחברות',
      en: 'Events & Catering',
    },
    id: EnumOfficeSupplyOptions.EVENTS_REFRESHMENTS,
    iconUrl: `${baseCdnUrl}/restaurant-cuisine-type-icon-image/cateringCategory.svg`,
    cuisineIdsToFilterBy: ['platters', 'eventCatering', 'corporateActivities'],
  },
];

export const cuisineIdsToFilterBy = uniq(flatMap(categories, cat => cat.cuisineIdsToFilterBy));
